module.exports = __webpack_public_path__ + "img/klaviyo-logo-1000.e5ecbfbf.png";